import React from 'react';
import { 
  Container, 
  Row, 
  Col, 
  Card, 
  CardBody, 
  CardHeader
} from "reactstrap";
import MainLayout from "../../layouts/MainLayout";

function PrivacyPage() {
  return (
    <MainLayout>
      <section className="py-5 bg-light" dir="rtl">
        <Container>
          <Row className="justify-content-center">
            <Col lg="10" md="12">
              <div className="text-center mb-5">
                <h1 className="mb-3">سياسة الخصوصية</h1>
                <p className="lead text-muted">
                  نحن نقدر خصوصيتك ونلتزم بحماية بياناتك الشخصية
                </p>
              </div>
              
              <Card className="border-0">
                <CardHeader className="bg-primary text-white">
                  <h3 className="mb-0">سياسة الخصوصية وحماية البيانات</h3>
                </CardHeader>
                <CardBody className="p-4">
                  <div className="privacy-content">
                    
                    <div className="mb-4">
                      <h4 className="text-primary mb-3">1. مقدمة</h4>
                      <p className="text-justify">
                        نحن في مشنص نحترم خصوصيتك ونلتزم بحماية بياناتك الشخصية. توضح هذه السياسة كيفية جمع واستخدام وحماية المعلومات التي تقدمها لنا عند استخدام موقعنا الإلكتروني وخدماتنا.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">2. المعلومات التي نجمعها</h4>
                      <p className="text-justify mb-2">نقوم بجمع الأنواع التالية من المعلومات:</p>
                      <ul className="text-justify">
                        <li><strong>المعلومات الشخصية:</strong> الاسم، البريد الإلكتروني، رقم الهاتف، العنوان</li>
                        <li><strong>معلومات الاستخدام:</strong> كيفية تفاعلك مع موقعنا الإلكتروني</li>
                        <li><strong>المعلومات التقنية:</strong> عنوان IP، نوع المتصفح، نظام التشغيل</li>
                        <li><strong>ملفات تعريف الارتباط:</strong> لتحسين تجربتك وتخصيص المحتوى</li>
                      </ul>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">3. كيف نستخدم معلوماتك</h4>
                      <p className="text-justify mb-2">نستخدم المعلومات المجمعة للأغراض التالية:</p>
                      <ul className="text-justify">
                        <li>تقديم وتحسين خدماتنا</li>
                        <li>التواصل معك والرد على استفساراتك</li>
                        <li>إرسال التحديثات والإشعارات المهمة</li>
                        <li>تخصيص تجربتك على الموقع</li>
                        <li>إجراء التحليلات لتحسين الأداء</li>
                        <li>الامتثال للمتطلبات القانونية</li>
                      </ul>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">4. مشاركة المعلومات</h4>
                      <p className="text-justify">
                        نحن لا نبيع أو نؤجر أو نشارك معلوماتك الشخصية مع أطراف ثالثة إلا في الحالات التالية:
                      </p>
                      <ul className="text-justify">
                        <li>عند الحصول على موافقتك الصريحة</li>
                        <li>لمقدمي الخدمات الذين يساعدوننا في تشغيل موقعنا</li>
                        <li>عند الاقتضاء القانوني أو بناءً على أمر من السلطات</li>
                        <li>لحماية حقوقنا وسلامة المستخدمين</li>
                      </ul>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">5. أمان البيانات</h4>
                      <p className="text-justify">
                        نتخذ تدابير أمنية مناسبة لحماية معلوماتك من الوصول غير المصرح به أو التغيير أو الإفصاح أو التدمير. نستخدم التشفير والجدران النارية وإجراءات الأمان الأخرى لحماية بياناتك.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">6. حقوقك</h4>
                      <p className="text-justify mb-2">لديك الحقوق التالية فيما يتعلق ببياناتك الشخصية:</p>
                      <ul className="text-justify">
                        <li><strong>الحق في الوصول:</strong> طلب نسخة من بياناتك الشخصية</li>
                        <li><strong>الحق في التصحيح:</strong> تصحيح أي معلومات غير دقيقة</li>
                        <li><strong>الحق في المحو:</strong> طلب حذف بياناتك الشخصية</li>
                        <li><strong>الحق في النقل:</strong> الحصول على بياناتك بتنسيق قابل للقراءة</li>
                        <li><strong>الحق في الاعتراض:</strong> الاعتراض على معالجة بياناتك</li>
                      </ul>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">7. ملفات تعريف الارتباط</h4>
                      <p className="text-justify">
                        نستخدم ملفات تعريف الارتباط لتحسين تجربتك على موقعنا. يمكنك التحكم في هذه الملفات من خلال إعدادات متصفحك. لمزيد من المعلومات، يرجى الاطلاع على سياسة ملفات تعريف الارتباط الخاصة بنا.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">8. الاحتفاظ بالبيانات</h4>
                      <p className="text-justify">
                        نحتفظ ببياناتك الشخصية فقط للمدة اللازمة لتحقيق الأغراض التي جُمعت من أجلها أو كما هو مطلوب بموجب القانون. بعد انتهاء هذه المدة، سيتم حذف البيانات أو إخفاء هويتها بشكل آمن.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">9. التغييرات على هذه السياسة</h4>
                      <p className="text-justify">
                        قد نقوم بتحديث هذه السياسة من وقت لآخر لتعكس التغييرات في ممارساتنا أو للأسباب التشغيلية أو القانونية أو التنظيمية. سنخطرك بأي تغييرات مهمة عبر البريد الإلكتروني أو من خلال إشعار على موقعنا.
                      </p>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">10. اتصل بنا</h4>
                      <p className="text-justify">
                        إذا كانت لديك أي أسئلة أو اهتمامات حول هذه السياسة أو ممارسات الخصوصية لدينا، يرجى التواصل معنا:
                      </p>
                      <div className="contact-info bg-light p-3 rounded">
                        <p className="mb-1"><strong>البريد الإلكتروني:</strong> contact@mishnis.net</p>
                        <p className="mb-1"><strong>الهاتف:</strong> <span dir='ltr'>+965 501 19333</span></p>
                        <p className="mb-0"><strong>العنوان:</strong> الكويت، العاصمه</p>
                      </div>
                    </div>

                    <div className="text-center mt-4 pt-4 border-top">
                      <p className="text-muted">
                        <small>آخر تحديث: {new Date().toLocaleDateString('ar-DZ', { 
                          year: 'numeric', 
                          month: 'long', 
                          day: 'numeric' 
                        })}</small>
                      </p>
                    </div>

                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </MainLayout>
  );
}

export default PrivacyPage;